// extracted by mini-css-extract-plugin
export default {"hideTooltip":"h9-z","fadeIn":"i9-z","delay":"j9-z","recommendedSizeTooltip":"k9-z"};